export default "__VITE_ASSET__DWBJuv$___"